/* eslint-disable */
import type { Money } from "../../common/currency.pb";
import type { CdfEvent } from "../analytics/cdfEvent.pb";
import type { LocalizableString } from "../localization/localization.pb";
import type { SplitButtons } from "../ui/SplitButtons.pb";
import type { SavingsAction } from "./common.pb";

/**
 * Describes the presentation of the Savings Home screen, and provides some
 * configuration for how flows triggered by this screen should behave
 */
export interface SavingsHome {
  options_section?: SavingsHomeSavingsOptionsSection;
  /** If not present, clients shouldn't render the Activity section */
  activity_section?: SavingsHomeActivitySection;
  transfers_section?: SavingsHomeTransfersSection;
}

export interface SavingsHomeSavingsOptionsSection {
  rows?: SavingsHomeSavingsOptionsSectionSavingsOptionRow[];
  accessibility_text?: string;
  localizable_accessibility_text?: LocalizableString;
}

export interface SavingsHomeSavingsOptionsSectionSavingsOptionRow {
  image?: SavingsHomeSavingsOptionsSectionSavingsOptionRowRowImage;
  title?: string;
  localizable_title?: LocalizableString;
  subtitle?: string;
  localizable_subtitle?: LocalizableString;
  action?: SavingsAction;
  accessibility_text?: string;
  localizable_accessibility_text?: LocalizableString;
  cdfEvent?: CdfEvent;
  row_id?: string;
}

export enum SavingsHomeSavingsOptionsSectionSavingsOptionRowRowImage {
  AUTOMATION = "AUTOMATION",
  FLAG = "FLAG",
  DART = "DART",
  ROUND_UP = "ROUND_UP",
}

export interface SavingsHomeActivitySection {
  accessibility_text?: string;
  localizable_accessibility_text?: LocalizableString;
}

export interface SavingsHomeTransfersSection {
  buttons?: SplitButtons;
  add_cash_config?: SavingsHomeTransfersSectionAddCashConfig;
  /** What should the primary button do if the balance is zero */
  primary_split_button_zero_balance_behavior?: SavingsHomeTransfersSectionAlternativeButtonBehavior;
  /** What should the secondary button do if the balance is zero */
  secondary_split_button_zero_balance_behavior?: SavingsHomeTransfersSectionAlternativeButtonBehavior;
  /** Introduced in 3.85 */
  transfer_out_config?: SavingsHomeTransfersSectionTransferOutConfig;
}

/**
 * Alternative (to opening the specified client route) behaviors
 * that buttons can exhibit.
 */
export enum SavingsHomeTransfersSectionAlternativeButtonBehavior {
  SHAKE_BALANCE = "SHAKE_BALANCE",
}

/**
 * "Add Cash" is a legacy, ambiguous name.
 * Read this as "TransferInConfig", analogous to TransferOutConfig.
 */
export interface SavingsHomeTransfersSectionAddCashConfig {
  /** Client expects 5 options. Any options over that number will be ignored. */
  quick_amounts?: Money[];
  initially_selected_amount?: Money;
  /** Introduced in 3.85 */
  minimum_amount?: Money;
  /** Introduced in 3.85 */
  maximum_amount?: Money;
}

export interface SavingsHomeTransfersSectionTransferOutConfig {
  minimum_amount?: Money;
}
